import React from 'react';

import { useAppSelector } from 'utils/hooks';

import activeEditor from 'domains/active_editor';
import photoModule from 'domains/photos';

import UploadPhotos from './UploadPhotos';
import PhotoOptionsMenu from './PhotoOptionsMenu';
import Filmstrip from './Filmstrip';

function Photos() {
  const photos = useAppSelector(photoModule.selectors.selectAll);
  const isCartProduct = useAppSelector(activeEditor.selectors.isCartProduct);

  return (
    <div className="user_photos" id="user_photos" onDrop={(e) => e.preventDefault()}>
      <UploadPhotos />
      {photos.length > 0 && !isCartProduct && <PhotoOptionsMenu />}
      <Filmstrip />
    </div>
  );
}

export default Photos;
